import React from 'react';
import { useForm } from '../context/FormContext';
import { HONEYPOT_FIELD } from '../utils/botCheck';

// The honeypot input. Rendered on every step of the wizard so a script that
// walks the form has the whole session to fall into it.
//
// 🔑 HIDING TECHNIQUE — positioned off-screen, NOT `display: none`.
// Some form-filling bots skip display:none inputs on the theory that a human
// cannot reach them, which would defeat the whole point. Off-screen text is
// still a live, focusable, fillable input as far as a naive script is
// concerned, while being completely invisible to a human.
//
// Three separate defenses against a FALSE POSITIVE on a real driver:
//   - aria-hidden + a label a screen reader is told to ignore, so assistive
//     technology never presents it and a blind driver cannot fill it
//   - tabIndex={-1}, so it is unreachable by keyboard tabbing
//   - autoComplete="off" plus a field name browser autofill will not match,
//     so a password manager does not helpfully type into it
export default function Honeypot() {
  const { state, dispatch } = useForm();

  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        whiteSpace: 'nowrap',
        left: '-9999px',
        top: 'auto',
      }}
    >
      <label htmlFor={HONEYPOT_FIELD}>Leave this field blank</label>
      <input
        type="text"
        id={HONEYPOT_FIELD}
        name={HONEYPOT_FIELD}
        value={state.botCheck.honeypot}
        onChange={(e) => dispatch({
          type: 'SET_BOT_CHECK',
          value: { honeypot: e.target.value },
        })}
        tabIndex={-1}
        autoComplete="off"
      />
    </div>
  );
}
